import { Injectable, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { IContextService, DomainContext } from '@pershing/pershing-core';
import { NxiContextUtils } from '@pershing/nxi-common';
import { NxiWidgetParamsService } from './NXI-WidgetParams.service';
import { NxiRestService } from './NXI-Rest.service';
@Injectable()
export class HistoryCommunicateService {
    invokeFirstComponentFunction = new EventEmitter();
    loading = new EventEmitter();
    download = new EventEmitter();
    subsVar2: Subscription;
    subsVar3: Subscription;
    subsVar: Subscription;
    nxiRestServiceUrl: any;
    activitySummaryParams: any;
    finalDate: any;
    subs: Subscription;
    acctRef: string;
    inputValue: string = '';
    summary: any;
    baseUrl: any;
    downloadLink: any;
    symbol: any;
    time: any;
    from: any;
    to: any;
    trans: any;
    checkbox: any;
    constructor(
        private contextService: IContextService,
        private httpClient: HttpClient,
        private nxiRestService: NxiRestService,
        private nxiWidgetParamsService: NxiWidgetParamsService) {
        this.nxiRestServiceUrl = this.nxiRestService.serviceUrl;
    }

    setParameters(symbol, time, from, to, trans, checkbox) {
        this.loading.emit();
        this.summary = undefined;
        this.symbol = symbol;
        this.time = time;
        this. from = from;
        this.to = to;
        this.trans = trans;
        this.checkbox = checkbox;
        this.subs = this.contextService.selectedDomainContext$.subscribe((domainContext: DomainContext<any>) => {
            let contextValue = NxiContextUtils.getContextFromDomainValue(domainContext);
            this.inputValue = contextValue.inputValue;
            this.acctRef = contextValue.hashValue;
            this.getActivitySummaryDownload();
            console.log('Account Reference', this.acctRef);
        });
    }

    fetchData() {
        const params = new HttpParams()
            .set('symbolValue', this.symbol.toUpperCase())
            .set('isFlatronSrc', 'true')
            .set('transactionType', this.trans)
            .set('timePeriodType', this.time)
            .set('excludeMMFSweepTxns', this.checkbox)
            .set('timePeriodFrom', this.from)
            .set('timePeriodTo', this.to);
        this.httpClient.get(this.baseUrl, {params}).subscribe(data => {
            if (data[0].activityDate !== null && data !== undefined) {
                this.summary = data;
                this.prepareData();
            }else {
                this.summary = null;
            }
            this.invokeFirstComponentFunction.emit();
        },
        err => this.invokeFirstComponentFunction.emit(),
        () => console.log('data recieved')
        );
    }

    getSummary() {
        return(this.summary);
    }

    getDownloadLink() {
        return(this.downloadLink);
    }

    prepareData() {
        for (let i of this.summary) {
            i['showDiv'] = false;
            i['accountHover'] = 0;
            i['activityHover'] = 0;
            i['activityWidth'] = 0;
            i['accountWidth'] = 0;
            i.acctObj.accountTitle = i.acctObj.accountTitle.replace(/ {5,}/g, '<br>') + ' - ' + i.accountNumber;
            let strSplit = i.acctObj.accountTitle.split('<br>');
            let longestWord = strSplit.sort(function(a, b) {return b.length - a.length; });
            i['accountWidth1'] = longestWord[0].length;
            i.commission = Number(i.commission);
            i.principal = Number(i.principal);
            if (i.commInLocCurr === null) {
                i.commInLocCurr = i.commission;
            }else {
                i.commInLocCurr = Number(i.commInLocCurr);
            }
            if (/\d/.test(i.symbol)) {
                i['linkShow'] = false;
            }else {
                i['linkShow'] = true;
            }
            if (i.activityDescription.indexOf('ISIN#') !== -1) {
                i['activityDescription1'] = i.activityDescription.substr(0, i.activityDescription.indexOf('ISIN#')).replace(/ {2,}/g, ' ');
            }else {
                i['activityDescription1'] = i.activityDescription.replace(/ {2,}/g, ' ');
            }
            i.activityDate = new Date(i.activityDate);
            i['activityDate1'] = i.activityDate;
            let month = String(i.activityDate.getMonth() + 1);
            if (month.length === 1) {
                month = '0' + month;
            }
            let day = String(i.activityDate.getDate());
            if (day.length === 1) {
                day = '0' + day;
            }
            i.activityDate = month + '/' + day + '/' + i.activityDate.getFullYear();
            i.settlementDate = new Date(i.settlementDate);
            i['settlementDate1'] = i.settlementDate;
            month = String(i.settlementDate.getMonth() + 1);
            if (month.length === 1) {
                month = '0' + month;
            }
            day = String(i.settlementDate.getDate());
            if (day.length === 1) {
                day = '0' + day;
            }
            i.settlementDate = month + '/' + day + '/' + i.settlementDate.getFullYear();
        }
        this.invokeFirstComponentFunction.emit();
    }

    getActivitySummaryDownload() {
        if (this.inputValue !== '' && this.acctRef !== '') {
            this.nxiWidgetParamsService.getWidgetParams(this.acctRef, 'activity').subscribe(
                resp => {
                    console.log(resp);
                    if (resp.response) {
                        resp.response.storeUrl = this.nxiRestServiceUrl + resp.response.storeUrl;
                        resp.response.modAPIUrl = 'https://api-netxselect.wsodqa.com';
                        this.finalDate = resp.response.asOfDate;
                        this.activitySummaryParams = resp.response;
                        console.log(resp.response);
                        this.baseUrl = this.activitySummaryParams.storeUrl.substr(0, this.activitySummaryParams.storeUrl.indexOf('?'));
                        this.downloadLink = this.nxiRestServiceUrl + '/portfolio/' + this.acctRef + '/activity/summary?transactionType='
                        + this.trans + '&timePeriodType=' + this.time + '&localeParam=en_US&download=true&gdr=true&isDownload=true&isGDR=true';
                        this.download.emit();
                        this.fetchData();
                        this.nxiWidgetParamsService.getWidgetParams(this.acctRef, 'activityLinkData').subscribe(
                            res => {
                                if (res.response) {
                                    res.response.downloadUrl = this.nxiRestServiceUrl + res.response.downloadUrl;
                                }
                            }
                        );
                    }
                }
            );
        }
    }

    getAsOf() {
        return (this.finalDate);
    }
}
